import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { NAV } from "../data/content";

const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -20, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    setTimeout(() => scrollToId(id), open ? 250 : 0);
  };

  return (
    <>
      <motion.nav
        data-testid="navbar"
        initial={{ y: -30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
        className="fixed left-0 right-0 top-0 z-[9000] px-6 md:px-14"
      >
        <div
          className="mt-4 flex items-center justify-between border-b py-4 transition-colors duration-500"
          style={{
            borderColor: scrolled ? "rgba(22,24,26,0.14)" : "transparent",
          }}
        >
          <button
            data-testid="nav-logo"
            onClick={() => (window.__lenis ? window.__lenis.scrollTo(0, { duration: 1.2 }) : window.scrollTo({ top: 0 }))}
            className="font-display text-base tracking-tight text-[#16181a]"
          >
            Gianni Ragone<span className="text-[#c0442b]">.</span>
          </button>

          <div className="hidden items-center gap-8 md:flex">
            {NAV.map((n) => (
              <button
                key={n.id}
                data-testid={`nav-link-${n.id}`}
                onClick={() => go(n.id)}
                className="font-body text-sm text-[#2a2b2d] transition-colors duration-300 hover:text-[#c0442b]"
              >
                {n.label}
              </button>
            ))}
          </div>

          <button
            data-testid="nav-cta"
            onClick={() => go("contatti")}
            className="hidden rounded-none border-b border-[#16181a] px-1 pb-1 font-body text-sm font-semibold text-[#16181a] transition-colors duration-300 hover:text-[#c0442b] md:block"
          >
            Contatti →
          </button>

          <button
            data-testid="nav-menu-toggle"
            className="text-[#16181a] md:hidden"
            onClick={() => setOpen((o) => !o)}
            aria-label="Menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </motion.nav>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
            className="fixed inset-0 z-[8999] flex flex-col items-start justify-center gap-3 px-10 md:hidden"
            style={{ background: "rgba(240,234,217,0.98)" }}
          >
            {NAV.map((n, i) => (
              <motion.button
                key={n.id}
                data-testid={`mobile-nav-link-${n.id}`}
                initial={{ opacity: 0, x: -30 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.08 * i + 0.1 }}
                onClick={() => go(n.id)}
                className="font-display text-4xl text-[#16181a]"
              >
                {n.label}
              </motion.button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export { scrollToId };
